const UA = navigator.userAgent;

const ConfigInfo = {
    httpType: {
        get: 'get',
        post: 'post',
        put: 'put',
        delete: 'delete'
    }, // http类型
    toastInfo: {
        reqErrorMsg: '网络请求错误，请重试',
        confirmMsg: '温馨提示',
        deleteSuccessMsg: '删除成功',
        saveSuccessMsg: '保存成功',
        updateSuccessMsg: '更新成功',
        warning: 'warning',
        success: 'success',
        error: 'error',
        danger: 'danger'
    },
    salt:'jcfzgdd0pqqney367lkpaydz3r3kvl93',
    // inWechat: (toString(UA.match(/MicroMessenger/i)) === 'micromessenger'), // 在微信环境
    inWechat: /MicroMessenger/i.test(window.navigator.userAgent), // 在微信环境
    isAndroid: UA.indexOf('Android') > -1 || UA.indexOf('Adr') > -1, // 是否为安卓
    isIos: !!UA.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // 是否为IOS
}
export default ConfigInfo
